// extracted by mini-css-extract-plugin
export var readonly = "_j1-1";
export var star = "_j1-0";